import React from "react";

function Sidebar() {
  return (
    <aside className="hidden w-52 rounded-2xl border border-slate-200 bg-white p-4 text-xs md:block">
      <h2 className="mb-4 text-[14px] font-semibold text-slate-800">Filters</h2>

      <div className="space-y-4">
        <div>
          <p className="mb-3 font-semibold text-[14px] text-slate-700">
            Retailers
          </p>
          <div className="space-y-3 text-[14px] text-slate-500">
            {["Tesco", "ASDA", "Sainsbury’s", "Morrisons"].map((item) => (
              <label key={item} className="flex items-center gap-2">
                <input type="checkbox" className="h-3.5 w-3.5" />
                <span>{item}</span>
              </label>
            ))}
          </div>
        </div>

        <div>
          <p className="mb-3 font-semibold text-[14px] text-slate-700">
            Preferences
          </p>
          <div className="space-y-3 text-[14px] text-slate-500">
            {["Organic", "Vegan"].map((item) => (
              <label key={item} className="flex items-center gap-2">
                <input type="checkbox" className="h-3.5 w-3.5" />
                <span>{item}</span>
              </label>
            ))}
          </div>
        </div>
      </div>
    </aside>
  );
}

export default Sidebar;